import { Modal, ModalContent } from '../Modal';
import { PasswordFormFields } from './PasswordFormFields';

interface Props {
  onClose(): void;
  open: boolean;
}

export const ChangePassword = ({ open, onClose }: Props) => (
  <Modal
    disableBackdropClick
    hideCloseButton
    maxWidth="sm"
    onClose={onClose}
    open={open}
  >
    <ModalContent>
      <h2 className="text-center text-xl text-white py-4 dark:bg-background-dark">
        Change Password
      </h2>
      <PasswordFormFields onClose={onClose} />
    </ModalContent>
  </Modal>
);
